var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeCommit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608 224H476.775C461.947 150.969 397.404 96 320 96S178.053 150.969 163.225 224H32C14.326 224 0 238.328 0 256S14.326 288 32 288H163.225C178.053 361.031 242.596 416 320 416S461.947 361.031 476.775 288H608C625.674 288 640 273.672 640 256S625.674 224 608 224ZM320 336C275.889 336 240 300.109 240 256S275.889 176 320 176S400 211.891 400 256S364.111 336 320 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCommit);
export default __webpack_public_path__ + "static/media/code-commit.ca3a1dcf2291923e3966171fa05a1462.svg";
export { ForwardRef as ReactComponent };